import React, { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import * as ConfigTypes from 'config/ConfigTypes';
import { getBaseName } from 'helpers/AppHelper';
import './Slider.scss';

function Slider(props) {
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    let baseName = getBaseName();
    if (baseName == '/') baseName = "";

    return (
        <div className="slider-box">
            <Carousel className="slider-image" interval={ConfigTypes.CAROUSEL_INTERVAL}
                activeIndex={index} onSelect={handleSelect}>
                {ConfigTypes.HOME_SLIDER_IMAGES.map((item, index) => (
                    <Carousel.Item key={`slider_${index}`}>
                        <div className="slider-img-box">
                            <img
                                className="d-block" alt="First slide"
                                src={`${baseName}/img/${item.value}`} />
                            <div className="slider-heading-box">
                                <div className="slider-heading">
                                    {ConfigTypes.HOME_HEADING.map((el, i) => (
                                        <div key={`sliderBoxHeading${i}`}>
                                            {props.formatMessage(el.intl)}
                                        </div>))}
                                </div>
                                <div className="slider-count">
                                    {`${index + 1}/${ConfigTypes.HOME_SLIDER_IMAGES.length}`}
                                </div>
                            </div>
                        </div>
                    </Carousel.Item>
                ))}
            </Carousel></div>
    );

}

export default Slider;